module.exports = __webpack_public_path__ + "media/images/flags/tt-740c30e3233373e9aad0fc0258cec876.svg";